type ApiErrorBody = {
  message?: unknown;
  type?: unknown;
};

function getErrorBody(error: unknown): ApiErrorBody | null {
  const err = error as {
    response?: { data?: unknown };
  };
  const data = err.response?.data;
  if (!data || typeof data !== "object") {
    return null;
  }
  return data as ApiErrorBody;
}

function messageText(body: ApiErrorBody): string {
  const { message } = body;
  if (typeof message === "string") {
    return message;
  }
  if (Array.isArray(message)) {
    return message.map(String).join(" ");
  }
  return "";
}

/** i18n message id for Google sign-in API errors, or null to use generic toast. */
export function googleSignInErrorMessageId(error: unknown): string | null {
  const body = getErrorBody(error);
  if (!body) {
    return null;
  }
  const type = typeof body.type === "string" ? body.type : "";
  switch (type) {
    case "GOOGLE_SIGN_IN_NOT_CONFIGURED":
      return "app.auth.googleNotConfigured";
    case "GOOGLE_INVALID_CREDENTIAL":
      return "app.auth.googleInvalidCredential";
    case "GOOGLE_NO_EMAIL":
      return "app.auth.googleNoEmail";
    case "GOOGLE_EMAIL_NOT_VERIFIED":
      return "app.auth.googleEmailNotVerified";
    case "GOOGLE_USER_NOT_ACTIVE":
      return "app.auth.googleUserNotActive";
    case "GOOGLE_FREE_TRIAL_PLAN_MISSING":
      return "app.auth.googlePlanMissing";
    default:
      return null;
  }
}

/** i18n message id for email/password session errors, or null for generic. */
export function passwordLoginErrorMessageId(error: unknown): string | null {
  const body = getErrorBody(error);
  if (!body) {
    return null;
  }
  const status = (error as { response?: { status?: number } }).response?.status;
  if (status !== 400) {
    return null;
  }
  const text = messageText(body);
  if (text.includes("Invalid Credentials")) {
    return "app.auth.invalidCredentials";
  }
  return null;
}
